export enum FieldRequiredValue {
	immediately = 'immediately',
	required = 'required',
	optional = 'optional',
	forbidden = 'forbidden',
	waivable = 'waivable',
}
